import { Box, Container } from "@mui/system";
import React from "react";
import Background from "../images/imagebgsection.jpeg";
import { Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import HubspotForm from "./HubspotForm";

// Update these constants to match the HubSpot newsletter signup form.
const HS_PORTAL_ID = "148454373";
const HS_FORM_ID = "32f4d07c-42f1-4784-82d2-2f8016ceeff6";
const HS_REGION = "eu1";

export default function Newsletter() {
  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          backgroundImage: "url(" + Background + ")",
          backgroundSize: "cover",
          p: {
            xs: "2rem 1rem",
            md: "2rem",
          },
          color: "#fff",
          display: "flex",
          width: "100%",
        }}
      >
        <Typography
          variant="p"
          component="p"
          sx={{
            lineHeight: 1.5,
            fontSize: "1.6rem",
            fontWeight: 600,
            flex: 1,
            flexBasis: "25%",
          }}
        >
          Sign up for updates
        </Typography>
        <HubspotForm
          portalId={HS_PORTAL_ID}
          formId={HS_FORM_ID}
          region={HS_REGION}
        />
      </Box>
      <Typography
        variant="p"
        component="p"
        sx={{
          m: "3rem 0",
        }}
      >
        We're committed to protecting your privacy. We will use the information
        you provide to us to contact you about our relevant content and
        services. Rest assured that we will not share your information with
        third parties. You can unsubscribe at any time.{" "}
        <Box
          component={RouterLink}
          to={"/privacy-policy-cookies/"}
          variant={"span"}
        >
          <strong>View our full Privacy Policy</strong>
        </Box>
        .
      </Typography>
    </Container>
  );
}
